module.exports = __webpack_public_path__ + "static/mordenkainens_sword-4689e8264b7f05e293d32dce03d7c75e.jpg";